import React from "react";
import { Provider } from "react-redux";
import { createReduxStore } from "./redux/store";
import ErrorBoundary from "../../components/errorBoundary/errorBoundary";
import { RawDataTableModule } from "./rawDataTableModule";
import './rawDataTable.scss'

const RawDataTable = (props) => (
  <Provider store={createReduxStore("rawDataTable")}>
    <ErrorBoundary {...props.notifications} moduleName={props.table_name}>
      <RawDataTableModule queryParams={props} />
    </ErrorBoundary>
  </Provider>
);

export default RawDataTable;
